<template>
  <section class="section quiz">
    <div class="container-medium">
      <h3 class="section__title quiz__title quiz__text--mobile">
        Вы можете пройти процедуру банкротства
      </h3>
      <p class="section__subtitle quiz__subtitle quiz__text--mobile">
        с любой суммой задолженности.
      </p>
      <p class="subtitle-purple quiz__text--mobile">
        Когда сумма задолженности <strong>от 200 000 рублей,</strong> то
        процедура банкротства становится экономически выгодной.
      </p>

      <div class="row quiz__row quiz__row--mobile">
        <div class="quiz__img quiz__img--mobile">
          <img src="img/quiz/dollars.png" alt="dollars" />
          <div class="quiz__dots">
            <img src="img/quiz/dots.png" alt="dots" />
          </div>
        </div>

        <div class="quiz__box quiz__box--mobile">
          <p class="quiz__box-title quiz__box-title--mobile">
            Получите результаты расчета, оставив контакты
          </p>
          <form id="form-quiz" @submit.prevent="addOrder" class="quiz__form">
            <div class="quiz__form-box">
              <input
                v-model="phone"
                :class="{
                  'is-invalid':
                    ($v.phone.$dirty && !$v.phone.required) ||
                    ($v.phone.$dirty && !$v.phone.isPhone),
                }"
                :disabled="isDisabled"
                id="quiz-phone"
                class="quiz__tel"
                placeholder="+7 (___) ___ - __ - __"
                type="tel"
              />
              <label
                class="invalid"
                v-if="$v.phone.$dirty && !$v.phone.required"
                >Обязательное поле.</label
              >
              <label
                class="invalid"
                v-else-if="$v.phone.$dirty && !$v.phone.isPhone"
                >Неверный формат номера</label
              >
            </div>

            <div class="quiz__button-group">
               
              <button
                id="quiz-send"
                :disabled="isDisabled"
                type="submit"
                class="button quiz__button"
              >
                Оставить заявку
                <div v-show="isDisabled" class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </button>
            </div>
            <label class="policy">
                <input v-model="policy" class="policy__input" type="checkbox">
                <span class="policy__ok"></span>
                <span class="policy__text">Я согласен(на) с <a href="/politic" target="_blank">политикой конфиденциальности</a></span>
                <span class="invalid-feedback invalid-feedback--policy" v-if="!$v.policy.agree && $v.$dirty">Дайте согласие.</span>
            </label>
          </form>
        </div>
      </div>
    </div>
    <div class="quiz__modal-wrap quiz__modal--hidden">
      <div class="quiz__modal">
        <div class="quiz__modal-close">
          <img src="img/quiz/close.png" alt="close" />
        </div>
        <div class="quiz__modal-img">
          <img src="img/quiz/message.png" alt="message" />
        </div>
        <p class="quiz__modal-title">Спасибо за ответы</p>
        <p class="quiz__modal-text">Ваши ответы приняты в обработку.</p>
        <p class="quiz__modal-text">
          В ближайшие 10 минут с Вами свяжется юрист.
        </p>
      </div>
      <!-- /.quiz__modal -->
    </div>
  </section>
</template>

<script>
import Inputmask from "inputmask";
import { minLength, required } from "vuelidate/lib/validators";

export default {
  name: "LastStep",
  data: () => ({
    phone: "",
    policy: true,
    polit: true,
    politDirty: false,
    isDisabled: false,
    counters: null,
    checkbox: true,
  }),
  computed: {
    getData() {
      return this.$store.getters.getDataAnswer;
    },
  },
  methods: {
    clearData() {
      this.phone = "";
      this.politDirty = false;
    },
    addOrder() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.isDisabled = true;
      axios
        .post("/api/order-quiz", {
          phone: this.phone.replace(/\D/g, ""),
          data: this.getData,
          host: window.location.host,
          referrer: document.referrer,
          url_query_string: sessionStorage.getItem('urlQueryString'),
        })
        .then((response) => {
          this.clearData();
          this.$v.$reset();
          this.isDisabled = false;
          if (response.status === 200) {
            if (this.counters.ym) ym(this.counters.ym, "reachGoal", "order");
            if (this.counters.fbq) fbq("track", "Contact");
            if (this.counters.mailTarget) {
              var _tmr = window._tmr || (window._tmr = []);
              _tmr.push({
                type: "reachGoal",
                id: ` "${this.counters.mailTarget.id}" `,
                goal: ` "${this.counters.mailTarget.goal}" `,
              });
            }
            setTimeout(() => this.$store.dispatch("viewOrHideThanks"), 500);
          }
        })
        .catch((error) => {
          this.isDisabled = false;
          console.log(error.message);
        });
    },
  },
  validations: {
    phone: {
      required,
      isPhone: (phone) => {
        const phoneRe = /^(8|7)[\d]{10}$/;
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          return phoneRe.test(digits);
        }
        return false;
      },
    },
     checkbox: { isCheck: (check) => check },
     policy: {
        agree: (value) => {
            return value
        }
    }
  },
  created() {
    axios
      .get("/api/counters")
      .then((response) => {
        this.counters = response.data;
      })
      .catch((error) => {
        console.log(error.message);
      });
  },
  mounted() {
    Inputmask({ mask: "+7 (999) - 999 - 99 - 99" }).mask("#quiz-phone");
  },
};
</script>

<style scoped>
.is-invalid {
  border: 1px solid #dc3545;
  color: #dc3545;
}

button[type="submit"]:disabled {
  color: #fff;
}

.invalid-feedback-head {
  position: relative;
}
.invalid-feedback {
  position: absolute;
  top: -1.5rem;
  left: 0;
  width: 100%;
  color: red;
}


.invalid-feedback--policy {
    text-align: center;
    top: auto;
    bottom: -15px;
}

.policy {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    /* width: 100%; */
    max-width: 410px;
    margin: 10px auto 15px;
    position: relative;
}

.policy__input {
    display: none;
}

.policy__ok {
    display: block;
    min-width: 20px;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    background-color: #fff;
    border: 1px solid #000;
}

.policy__ok:after {
    content: "";
    width: 30px;
    height: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url('../../img/ok.svg') no-repeat center/contain;
    display: none;
}


.policy__input:checked+.policy__ok:after {
    display: block;
}

.policy__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: left;
}

.policy__text a {
    font-size: 14px;
    color: #111419;
    text-decoration: underline;
}
</style>
